import React, { useState, useEffect } from 'react';
import { Container, Card, Form, Row, Col, Button } from 'react-bootstrap';
import blogs from './blogData'; // Import the blog data

const BlogList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 5;

  const filteredBlogs = blogs.filter(blog =>
    blog.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    blog.content.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Function to sort blogs by date in descending order
  const sortBlogsByDate = (blogsArray) => {
    return blogsArray.sort((a, b) => {
      const dateA = new Date(a.date.split('-').reverse().join('-'));
      const dateB = new Date(b.date.split('-').reverse().join('-'));
      return dateB - dateA;
    });
  };

  // Filtered and sorted blogs by search term and date
  const filteredAndSortedBlogs = sortBlogsByDate(filteredBlogs);

  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = filteredAndSortedBlogs.slice(
    indexOfFirstBlog,
    indexOfLastBlog
  );

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const paginate = pageNumber => setCurrentPage(pageNumber);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Optionally, you can change this to 'auto' for instant scrolling
    });
  };

  useEffect(() => {
    // Scroll to top when currentPage changes
    scrollToTop();
  }, [currentPage]);

  return (
    <Container className="my-4">
      <Card className="radius-15 text-light bg-black mb-4">
        <Card.Body>
          <Row className="mb-3">
            <Col>
              <h1 className="text-light">Blog Posts</h1>
            </Col>
            <Col>
              <Form.Control
                type="text"
                placeholder="Search blogs by keyword"
                value={searchTerm}
                onChange={handleSearch}
                className="bg-dark-subtle shadow"
              />
            </Col>
          </Row>

          <Row>
            {currentBlogs.map(blog => (
              <Col md={12} className="mb-4" key={blog.id}>
                <Card className="bg-dark text-light radius-15">
                  <Card.Body>
                    <Row>
                      {blog.image &&
                        <Col md={2}>
                          <Card.Img src={blog.image} alt={blog.title} className="img-fluid radius-15 mb-2 mr-3" />
                        </Col>
                      }
                      <Col>
                        <Card.Title>
                          <a href={blog.url} target="_blank" className='text-reset fw-bold text-decoration-none' rel="noopener noreferrer">{blog.title}</a>
                        </Card.Title>
                        <Card.Text>{blog.content}</Card.Text>
                        <Row className="align-items-center">
                          <Col>
                            <p className="card-text"><small className="text-secondary">Published on {blog.date}</small>
                            {blog.source && <small className="text-secondary"><br></br>Source: {blog.source}</small>}</p>
                          </Col>
                          <Col xs="auto">
                            <a href={blog.url} target="_blank" className='text-decoration-none' rel="noopener noreferrer"><small>Read More</small></a>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Pagination */}
          <nav>
            <ul className="pagination justify-content-center">
              {Array(Math.ceil(filteredAndSortedBlogs.length / blogsPerPage))
                .fill()
                .map((_, index) => (
                  <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                    <Button onClick={() => paginate(index + 1)} className="page-link">
                      {index + 1}
                    </Button>
                  </li>
                ))}
            </ul>
          </nav>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default BlogList;
